import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "5",
      cy: "5",
      r: "5",
      fill: "#FF541E"
    }, null, -1),
    _createElementVNode("path", {
      d: "M3 3L6.99998 7",
      stroke: "white",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7 3L3.00002 7",
      stroke: "white",
      "stroke-linecap": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }